import Store from "@/store/index";

import Error404 from "@/pages/404";
import Error403 from "@/pages/403";

export default [
    {
        path: "/error-404",
        name: "error-404",
        component: Error404,
        meta: {
            title: "404",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/error-403",
        name: "error-403",
        component: Error403,
        meta: {
            title: "403",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
